import interceptorAxios from './InterceptorAxios';

const ServicioTrabajador={
   
   paginacion(objeto){
        return interceptorAxios.post('/trabajador/paginacion.json',objeto);
    },

    buscar_like(objeto){
        return interceptorAxios.post('/trabajador/buscar_like.json',objeto);
    },
    obtener_nombre_trabajador(){
        return interceptorAxios.post('/trabajador/obtener_nombre.json');
    },

    guardar(objeto){
        return interceptorAxios.post('/trabajador/guardar.json',objeto)
    },

    editar(objeto){
        return interceptorAxios.post('/trabajador/guardar.json',objeto)
    },
    buscar_rfc_trabajador(objeto){
        return interceptorAxios.post('/trabajador/buscar_rfc_trabajador.json',objeto);
    },
    buscar_curp_trabajador(objeto){
        return interceptorAxios.post('/trabajador/buscar_curp_trabajador.json',objeto);
    },
    buscar_nss_trabajador(objeto){
        return interceptorAxios.post('/trabajador/buscar_nss_trabajador.json',objeto);
    }
    
}

export default ServicioTrabajador;